<div id="comicPage" (keydown.ArrowLeft)="onLeft()" (keydown.ArrowRight)="onRight()" autofocus tabindex="-1">
    <div id="comicViewPane" style="min-height: 300px; min-width: 300px;">
        <mat-card>
            <mat-card-actions>
                <mat-form-field appearance="fill">
                    <mat-label>Chapter Number</mat-label>
                    <mat-select appearance="fill" (selectionChange)="onChange($event.value)">
                    <mat-option [value]="0">
                        Pilot
                    </mat-option>
                    <mat-option [value]="1">
                        Chapter 1
                    </mat-option>
                    </mat-select>
                </mat-form-field>
                <div>
                    <div style="float:left; ">
                        <a mat-raised-button color="accent" *ngIf="showPrevious()"  routerLink="/comic/{{chapterNumber}}/page/{{imageNumber - 1}}"> PREVIOUS </a>
                    </div>
                    <div style="float:right; ">
                        <a mat-raised-button color="accent" *ngIf="showNext()" routerLink="/comic/{{chapterNumber}}/page/{{imageNumber + 1}}"> NEXT </a>
                    </div>
                    <div style="float:right; ">
                        <a mat-raised-button color="accent" *ngIf="!showNext()" (click)="onNextChapter()"  > NEXT CHAPTER </a>
                    </div>
                </div>
                <div style="margin-left:40%; margin-right: 40%;">
                    <select id="pageNumber" (change)="onPageSelectChange($event.target.value)">
                        <option *ngFor="let pageNum of getPageNumbers();" [selected]="pageNum == imageNumber" [value]="pageNum">
                        {{ pageNum }}
                        </option>
                    </select>
                    <a mat-raised-button color="accent" routerLink="/comic/{{latestChapter}}/page/{{latestPage}}"> LATEST </a>
                </div>
            </mat-card-actions>
            <mat-card-title>	
                <h1>Chapter {{chapterNumber}} : Page {{imageNumber}}</h1>
            </mat-card-title>
            <mat-card-content></mat-card-content>
            <img mat-card-image src="{{ imageLink }}" alt="Page_1">
            <mat-divider [inset]="true"></mat-divider>
            <mat-card-actions>
                <div>
                    <div style="float:left; ">
                        <a mat-raised-button color="accent" *ngIf="showPrevious()"  routerLink="/comic/{{chapterNumber}}/page/{{imageNumber - 1}}"> PREVIOUS </a>
                    </div>
                    <div style="float:right; ">
                        <a mat-raised-button color="accent" *ngIf="showNext()" routerLink="/comic/{{chapterNumber}}/page/{{imageNumber + 1}}"> NEXT </a>
                    </div>
                    <div style="float:right; ">
                        <a mat-raised-button color="accent" *ngIf="!showNext()" (click)="onNextChapter()"  > NEXT CHAPTER </a>
                    </div>
                </div>
                <div style="margin-left:40%; margin-right: 40%;">
                    <select id="pageNumber" (change)="onPageSelectChange($event.target.value)">
                        <option *ngFor="let pageNum of getPageNumbers();" [selected]="pageNum == imageNumber" [value]="pageNum">
                        {{ pageNum }}
                        </option>
                    </select>
                    <a mat-raised-button color="accent" routerLink="/comic/{{latestChapter}}/page/{{latestPage}}"> LATEST </a>
                </div>
            </mat-card-actions>
        </mat-card>
    </div>
</div>